import onArchiveClinic from './onArchiveClinic';
import onGetClinic from './onGetClinic';
import onGetClinics from './onGetClinics';
import onRestoreClinic from './onRestoreClinic';
import onGetMyClinic from './onGetMyClinic';
import onDisableEdits from './onDisableEdits';

export default {
  onArchiveClinic,
  onGetClinic,
  onGetClinics,
  onRestoreClinic,
  onGetMyClinic,
  onDisableEdits,
};
